<template>
  <rest
    :remote="remote"
    :table-columns="tableColumns"
    :formInitialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :export-visible="true"
    :create-able="true" :update-able="true" :delete-able="true"
    :use-drawer="true"
    drawer-width="50%"
  >
  </rest>
</template>

<script>
import Rest from '@/components/Spring/Rest.vue'
export default {
  name: 'wikiVpcs',
  components: { Rest },

  data () {
    return {
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: true,
        createLabel: '新增VPC规划'
      },
      formInitialize: {
        seq: 0
      },
      formRules: {
        vpc: [{ required: true, message: '请填写 VPC' }],
        region: [{ required: true, message: '请填写 地区' }],
        isp: [{ required: true, message: '请填写 服务商' }],
        company: [{ required: true, message: '请填写 公司' }]
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', hiddenForm: true, minWidth: 90 },
        { label: '序号', prop: 'seq', minWidth: 90 },
        { label: 'VPC', prop: 'vpc', minWidth: 180 },
        { label: '子网', prop: 'subnet', minWidth: 180 },
        { label: '地区', prop: 'region', minWidth: 140 },
        { label: '服务商', prop: 'isp', minWidth: 140 },
        { label: '公司', prop: 'company', minWidth: 180 },
        { label: '备注', prop: 'note', type: 'textarea', showOverflowTooltip: true, minWidth: 220 }
        // { label: '创建时间', prop: 'createdAt', type: 'datetime', hiddenForm: true },
        // { label: '修改时间', prop: 'updatedAt', type: 'datetime', hiddenForm: true }
      ]
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
